import { parseStoryJson, sollTippZeigen } from './story.js'

export function wendeStoriesAnMatchAn(match, liste, bildBasisUrl) {
  const sortiert = [...liste].sort((a, b) =>
    new Date(a.updatedAt ?? a.createdAt).getTime() - new Date(b.updatedAt ?? b.createdAt).getTime()
  )
  for (const eintrag of sortiert) {
    if (eintrag.matchId !== match.id || !eintrag.text) continue
    const phase = eintrag.phase === 'preview' ? 'Preview' : eintrag.phase === 'report' ? 'Report' : null
    if (!phase) continue

    match['story' + phase] = eintrag.text
    const daten = parseStoryJson(eintrag, bildBasisUrl)
    match['storyDaten' + phase] = daten
    if (daten) {
      daten.heim = daten.heim || match.heim
      daten.auswaerts = daten.auswaerts || match.auswaerts
      daten.quote_1 = eintrag.quote_1
      daten.quote_X = eintrag.quote_X
      daten.quote_2 = eintrag.quote_2
      daten.timeMatch = eintrag.timeMatch
      daten.createdAt = eintrag.createdAt
      daten.zeigeTipp = sollTippZeigen(daten.status)
    }
  }
}